/* eslint-disable react/default-props-match-prop-types, react/require-default-props */
import React, { memo, useContext } from 'react';
import _ from 'underscore';
import classNames from 'classnames';

import { I18nContext, I18nModel } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpPopup } from './help-popup';
import { IComponentWithStatics } from './types';

interface IInlineHelpStyles {
  inlineHelp: string;
  withSpace?: string;
}

export interface IInlineHelpProps {
  topic: string;
  withoutSpace?: boolean;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  ariaLabel?: string | null;
  classes?: IInlineHelpStyles;
}

export const InlineHelpUnstyled: IComponentWithStatics<IInlineHelpProps> = memo((props: IInlineHelpProps) => {
  const {
    classes,
    topic,
    withoutSpace,
    onClick,
    ariaLabel,
  } = props;

  const i18n: I18nModel = useContext(I18nContext);

  return (
    <span
      className={classNames({
        [classes && classes.inlineHelp ? classes.inlineHelp : '']: true,
        [classes && classes.withSpace ? classes.withSpace : '']: !withoutSpace,
      })}
      role="presentation"
      onClick={onClick}
    >
      <HelpPopup
        aria-label={ariaLabel || i18n.getString(_TL_('Learn more'))}
        topic={topic}
      />
    </span>
  );
});

InlineHelpUnstyled.defaultProps = {
  withoutSpace: false,
  onClick: _.noop,
  ariaLabel: null,
};

export const HelpPopupInline = withDefaultStyles(
  InlineHelpUnstyled as React.ComponentType<IInlineHelpProps>,
  (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
    inlineHelp: {
      display: 'inline-block',
      fontSize: '15px !important',
      fontWeight: 'normal',

      '& .helpbutton': {
        paddingTop: '2px',
        paddingLeft: '2px',

        '&::before': {
          content: '"\\E9CE"',
          fontFamily: iconFontFamily,
          position: 'relative',
          top: 2,
        },

        '&:focus': {
          outline: '1px solid',
          outlineColor: palette.neutralSecondary,
          border: 'none',
          color: palette.black,
          textDecoration: 'none',
        },

        '&:hover': {
          backgroundColor: palette.neutralLighter,
          color: palette.black,
          textDecoration: 'none',
        },

        '&:active': {
          backgroundColor: palette.neutralLight,
          color: palette.black,
          textDecoration: 'none',
        },
      },
    },

    withSpace: {
      marginLeft: 3,
    },
  })
);
